export default __webpack_public_path__ + "static/media/card3.4ae660d6.svg";